import { getCountryCallingCode, isValidPhoneNumber } from "react-phone-number-input";

const JAM_Codes = ["876", "658"];
const CA_Codes = [
    "204",
    "226",
    "250",
    "289",
    "306",
    "506",
    "514",
    "519",
    "587",
    "604",
    "613",
    "705",
    "709",
    "778",
    "807",
    "819",
    "905",
    "902",
    "782",
    "236",
    "249",
    "343",
    "365",
    "403",
    "416",
    "418",
    "431",
    "437",
    "438",
    "450",
    "548",
    "579",
    "581",
    "639",
    "647",
    "672",
    "780",
    "825",
    "867",
    "873",
    "263",
    "428",
    "879",
    "382",
    "942",
    "753",
    "257",
    "354",
    "468",
];

export const isValidPhoneNo = (country: string, phoneNumber: string) => {
    let isValid = false;
    if (country === "US") {
        isValid = isValidPhoneNumber(phoneNumber);
        if (isValid) {
            for (let jcode of JAM_Codes) {
                if (phoneNumber.startsWith("+1" + jcode)) {
                    isValid = false;
                    break;
                }
            }
            if (isValid) {
                for (let ccode of CA_Codes) {
                    if (phoneNumber.startsWith("+1" + ccode)) {
                        isValid = false;
                        break;
                    }
                }
            }
        }
    } else if (country === "JM") {
        isValid = isValidPhoneNumber(phoneNumber);
        if (isValid) {
            for (let JAMC of JAM_Codes) {
                if (phoneNumber.startsWith("+1" + JAMC)) {
                    isValid = true;
                    break;
                } else {
                    isValid = false;
                }
            }
        }
    } else if (country === "CA") {
        isValid = isValidPhoneNumber(phoneNumber);
        if (isValid) {
            for (let CAC of CA_Codes) {
                if (phoneNumber.startsWith("+1" + CAC)) {
                    isValid = true;
                    break;
                } else {
                    isValid = false;
                }
            }
        }
    } else {
        isValid = isValidPhoneNumber(phoneNumber);
    }
    if (isValid) {
        if (!phoneNumber.startsWith("+" + getCountryCallingCode(country))) {
            isValid = false;
        }
    }
    return isValid;
};
